import React from 'react'
import PropTypes from 'prop-types'
import Avatar from 'components/ContentBox/Company/Teachers/Avatar'
import { colors } from 'components/ContentBox/Global/ContentTable_test/avatar'
import { dateFormat } from 'helpers/date'
import { localisationMaster, translate as loc } from 'Localisation/Localisation'
import { checkPermList, classNames as cn } from 'helpers'
import Stores from 'Stores'
import st from './UserInfo.module.scss'
import { ReactComponent as CameraIcon } from '../Employee/img/camera-switch-line.svg'
import { ReactComponent as UserIsActiveIcon } from '../Employee/img/user_isActive_status.svg'
import InterpressMoney from './img/money.png'
import { ageToStr } from '../functions'
import { dict } from 'Localisation'
import swal from 'sweetalert'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import AddMoney from '../../../ContentBox/Global/GlobalModalSingle/templates/InterpressMoney/AddMoney'
import { permissions } from 'settings/permissions'
import modalStore from 'Stores/modalStore'
import userStore from 'Stores/userStore'
import { observer } from 'mobx-react'

const UserInfo = ({
  user: { profile, ...user },
  updateProfile,
  fetchClient,
  ...props
}) => {
  // Модальное окно аватара
  const modalAvatarSettings = {
    name: 'companies',
    link: 'accounts/account_update/' + user.id,
    media: true,
    is_put: true,
    button: localisationMaster('modal_title_1', 'company/profiles/account'),
    title: localisationMaster('modal_title_2', 'company/profiles/account'),
    data: 'media',
    name_media: 'avatar',
    type: 'AddAvatar',
    func: (data) => {
      updateProfile(data)
      userStore.setAvatar(data.profile.avatar)
    },
  }

  // Пополнение баланса
  const addBalance = () => {
    const body = {
      name: 'addPayment',
      link: 'payments/pay_orders',
      button: loc(dict.main_page.add),
      title: `${localisationMaster('title', 'pays/create-pay')}: ${profile.full_name}`,
      type: 'addPayment',
      data: 'json',
      isResponsive: true,
      client_id: profile?.id,
      onSubmitSuccess: (res) => {
        window.location.href = '/pays/invoice-details/' + res.order_id
      },
      valid: {
        amount: 'more_than_100',
      },
    }
    asideModalStore.activity(body, {
      id: profile.user_id,
      status_sending_mail: 'need_mail',
      amount: 0,
      client_id: profile?.id,
    })
  }

  // Пополнение Money
  const addMoney = () => {
    const body = {
      modalBodyComponent: () => <AddMoney />,
      link: 'ledger/client_coins',
      button: 'Пополнить',
      title: `Пополнить Interpress Money`,
      isResponsive: true,
      onSubmitSuccess: () => {
        fetchClient(user.id)
      },
      valid: {
        sum: 'required',
        comment: 'required',
      },
    }
    asideModalStore.activity(body, { client: profile?.id })
  }

  const changeActiveHandler = () => {
    const is_active = profile.is_active
    swal({
      title: localisationMaster('text_2', 'alert'),
      text: `Вы действительно хотите перевести клиента ${profile.full_name} в статус ${is_active ? 'неактивный' : 'активный'}? ${!is_active ? '' : 'Клиент утратит доступ в личный кабинет'}`,
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const json = {
          is_active: !is_active,
        }
        let apiConf = {
          method: 'put',
          link: 'accounts/account_update/' + user.id,
        }
        superAxiosRequest(apiConf, json).then((res) => {
          const is_active = res.data.profile.is_active
          //setActive(is_active)
          updateProfile(res.data)
          swal(
            '',
            `Вы перевели клиента ${profile.full_name} в статус ${is_active ? 'активный' : 'неактивный'}`,
            'success',
          )
        })
      } else {
        swal('Действие отменено')
      }
    })
  }

  return (
    <div className={st.userInfo}>
      <div className={st.header}>
        <div className={st.avatar}>
          {profile.avatar ? (
            <Avatar link={Stores.baseLink() + profile.avatar} />
          ) : (
            <div
              className={st.nameAvatar}
              style={{
                backgroundColor: colors(
                  (profile.first_name || '') + (profile.last_name || ''),
                ),
              }}
            >
              <div>
                {Stores.transliterate(
                  (profile.first_name?.[0] || '').toUpperCase() +
                    (profile.last_name?.[0] || '').toUpperCase(),
                )}
              </div>
            </div>
          )}
          <div
            className={st.cameraBtn}
            onClick={() => modalStore.activity(modalAvatarSettings)}
          >
            <CameraIcon />
          </div>
        </div>
        <div className={st.info}>
          <div>{`${Stores.transliterate(profile.first_name)} ${Stores.transliterate(profile.last_name)}`}</div>
          <div>id: {profile.id}</div>
          <div>{`${ageToStr(profile.date_of_birth)} | ${dateFormat(profile.date_of_birth, 'd MMM YYYY')}`}</div>
        </div>
        <div className={st.topUpBalance} onClick={addBalance}>
          {props.translate.top_up_balance}
        </div>

        {checkPermList(permissions.add_client_coin) && (
          <div className={st.topUpBalance} onClick={addMoney}>
            Пополнить Interpress Money
          </div>
        )}

        <div className={st.money}>
          <img src={InterpressMoney} alt='Interpress Money' />
          <div>
            <div>Interpress Money (IPM)</div>
            <div className={st.sum}>{profile?.coins?.all}</div>
            {profile?.activity_level && (
              <div className={st.level}>{profile?.activity_level}</div>
            )}
          </div>
        </div>
        {Stores.Rules.checkRule('user_is_active', ['view', 'view_own']) && (
          <div
            onClick={changeActiveHandler}
            className={`${st.statusBtn} ${profile.is_active ? st.green : st.red}`}
          >
            <UserIsActiveIcon />
          </div>
        )}
      </div>
      <ul className={st.menu}>
        {props.tabs.map((tab) => (
          <li
            key={tab.id}
            className={cn({
              [st.menuItem]: true,
              [st.menuItemSelected]: tab.id === props.currentTab,
            })}
            onClick={() => props.onChangeTab(tab.id)}
          >
            {tab.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

UserInfo.propTypes = {
  user: PropTypes.object.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      tab: PropTypes.element,
    }),
  ),
  currentTab: PropTypes.number,
  onChangeTab: PropTypes.func,
}

export default observer(UserInfo)
